import { render, staticRenderFns } from "./PreRegistration.vue?vue&type=template&id=38c3e5fe&"
import script from "./PreRegistration.vue?vue&type=script&lang=js&"
export * from "./PreRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PreRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports